import { Label as LabelDs, LoadingIcon as LoadingDs } from "@packages/ds";
import InfiniteScroll from "react-infinite-scroller";
import styled, { css } from "styled-components";

import {
  calcColumn,
  DEFAULT_COL_SIZE
} from "src/common/components/MaxWidthContainer/MaxWidthContainer";

export const StyledInfiniteScroll = styled(InfiniteScroll)``;

export const LabelWrapper = styled.div`
  display: flex;
  margin: -8px -32px 0;
  padding: 0 32px;
  border-bottom: 1px solid
    var(--section-color-primary-100-border-color, var(--color-primary-100));
`;

const nameCol = css`
  width: 100%;
`;

const columnStyle = css`
  @media (min-width: 1024px) {
    width: ${calcColumn(DEFAULT_COL_SIZE, 2)}%;
    min-width: ${calcColumn(DEFAULT_COL_SIZE, 2)}%;
  }
`;

export const ColumnLabel = styled(LabelDs)<{
  type: "name" | "owner" | "region" | "plan" | "id";
}>`
  display: flex;
  align-items: center;
  flex-wrap: nowrap;

  ${({ type }) => (type === "name" ? nameCol : columnStyle)}

  @media (max-width: 1024px) {
    min-width: 20%;
  }
`;

export const Loading = styled(LoadingDs)<{ isGrid: boolean }>`
  ${({ isGrid }) =>
    isGrid
      ? css`
          justify-self: center;
          grid-column: 1 / span 1;
          @media (min-width: 834px) {
            grid-column: 1 / span 2;
          }
          @media (min-width: 1280px) {
            grid-column: 1 / span 3;
          }
          @media (min-width: 1920px) {
            grid-column: 1 / span 4;
          }
        `
      : css`
          display: flex;
          margin: 10px auto 0;
        `}
`;
